import 'videojs-share';
import createEmbedCode from '../util/embed';

export default {
  mapPropStateToOptions: props => {
    const params = {
      id: props.mediaId,
    };

    // Only add the vertical param when its truthy.
    if (props.vertical) {
      params.vertical = props.vertical;
    }

    return {
      url: document.referrer,
      title: props.title,
      description: 'BNNVARA player share',
      embedCode: createEmbedCode({
        width: props.width,
        height: props.height,
        vertical: props.vertical,
        params,
      }),
    };
  },
};
